// Offers routes
export default [
  {
    path: 'approval-customer-changes',
    name: 'approval-customer-changes',
    redirect: 'approval-customer-changes/index',
    component: () =>
      import(
        /* webpackChunkName: "approvalCustomerChanges" */ '../views/approvalCustomerChanges/ApprovalCustomerChanges.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'approvalCustomerChangesIndex',
        meta: {
          tabbable: true,
          tableKeys: ['approvalCustomerChanges'],
          filterKeys: ['approvalCustomerChanges'],
          formKeys: [],
          routePermissions: ['signatureUser'],
        },
        component: () =>
          import(
            /* webpackChunkName: "approvalCustomerChangesIndex" */ '../views/approvalCustomerChanges/ApprovalCustomerChangesIndex.vue'
          ),
      },
    ],
  },
];
